import { ButtonLinkTitle } from '@app/ui/atoms'
import { MouseEventHandler } from 'react'

type props = { onClick?: MouseEventHandler<HTMLElement> | undefined }

export const ButtonTitleEdit = ({ onClick }: props) => (
  <ButtonLinkTitle onClick={onClick} title="general.edit" />
)
